import { PropsWithChildren } from 'react';

export const Show = ({ when, children }: PropsWithChildren<{ when: boolean }>) => {
  if (!when) {
    return null;
  }

  return children;
};
